// QUÉ GRABA ESTE NAVEGADOR (B-986, 3-oct-2026). Lo usan la grabadora del chat del portal (hooks/useGrabadoraNota) y la
// nota de voz de /whatsapp (pages/Conversaciones.jsx): WebM con Opus si se puede (Chrome, Android, Firefox), MP4 si no
// (el iPhone, que no graba WebM hasta las versiones más nuevas). Pedirle a un iPhone «audio/webm» a ciegas hacía que la
// grabadora no arrancara. Sin dependencias: se puede ejecutar en una guardia.

export function elegirMimeGrabacion(ventana) {
  const w = ventana || (typeof window !== 'undefined' ? window : null)
  const MR = w ? w.MediaRecorder : null
  if (!MR || typeof MR.isTypeSupported !== 'function') return ''
  for (const m of ['audio/webm;codecs=opus', 'audio/webm', 'audio/mp4', 'audio/ogg;codecs=opus']) {
    try { if (MR.isTypeSupported(m)) return m } catch (_) { /* sigue */ }
  }
  return ''
}

// La extensión del archivo según lo grabado (el servidor decide por ella qué es).
export const extensionDeNota = (mime) => (/mp4|aac/.test(String(mime || '')) ? 'm4a' : (/ogg/.test(String(mime || '')) ? 'ogg' : 'webm'))

// ¿Este navegador puede grabar? (sin micrófono o sin MediaRecorder, el botón no se ofrece)
export function puedeGrabar(ventana) {
  const w = ventana || (typeof window !== 'undefined' ? window : null)
  return !!(w && w.navigator && w.navigator.mediaDevices && typeof w.navigator.mediaDevices.getUserMedia === 'function'
    && typeof w.MediaRecorder === 'function')
}

// ¿Se puede PAUSAR una grabación y seguir en la MISMA? (t147, 8-oct-2026: el botón de pausa de las notas de voz del Modo
// doctor.) `MediaRecorder.pause()` y `resume()` siguen grabando en el mismo archivo, sin cortarlo en dos: los traen
// Chrome, Android, Firefox, Edge y Safari (iPhone desde iOS 14.5). Donde no estén, el botón de pausa no se ofrece.
export function puedePausarGrabacion(ventana) {
  const w = ventana || (typeof window !== 'undefined' ? window : null)
  const MR = w ? w.MediaRecorder : null
  const p = typeof MR === 'function' ? MR.prototype : null
  return !!(p && typeof p.pause === 'function' && typeof p.resume === 'function')
}
